import React from 'react';
import "./ProgrammingLanguage.css";

export default function ProgrammingLanguages() {

  const value = [

    { text: "javascript", percentage: 50 },
    { text: "java", percentage: 80 },
    { text: "node js", percentage: 80 },
    { text: "react js", percentage: 80 },
    { text: "android", percentage: 80 },
    { text: "kotlin", percentage: 80 },

  ];

  return (
    <div>
      <div className="row">
        {value.map((value, index) => {
          return (
            <>
              <div className="col-lg-6 col-mg-6 col-sm-12 my-2">
                <span className="programming-langauge">{value.text} </span>
                <div className="progress-pl">
                  <div
                    className="progress-current"
                    style={{ width: `${value.percentage}%` }}
                  >
                    {" "}
                  </div>
                </div>
              </div>
            </>
          );
        })}
      </div>
    </div>
  );
}